import React from "react";
import { useTranslation } from "react-i18next";
import DivShadow from "@components/layout/DivShadow";
import Button from "@components/ui/Button";
import { useThemeStore } from "@shared/stores";
import { QuickButtonEntity } from "@features/settings/services/entities/organizerSettingEntity";
import { useNavigate } from "react-router-dom";
import { MagnifyingGlass } from "@/pages/taskpane/components/icons/IconCustom";
import { routes } from "@/pages/taskpane/shared/constants/routes";

type Props = {
  isShowButtonSearch?: boolean;
};

const NavigateSearch = ({ isShowButtonSearch = true }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isDarkMode } = useThemeStore();

  const handleNavigate = () => {
    navigate(routes.search);
  };

  // const { quickButtons } = useSettingStore();

  const handleRenderQuick = (quick: QuickButtonEntity) => {
    return (
      <div
        key={quick.id}
        className="w-full h-[32px] rounded-[4px] flex justify-center items-center gap-1 py-1 cursor-pointer text-xs hover:bg-softBlue hover:text-darkPrimaryBlue dark:hover:text-coolBlue dark:hover:bg-deepPrimaryBlue"
        // onClick={() => navigate(routes.quickSearch + "?quickType=" + quick.type)}
      >
        <p className="text-center text-xs truncate">{quick.name}</p>
      </div>
    );
  };

  return (
    <DivShadow className="flex flex-col gap-2 px-5 py-2 bg-veryLightGray dark:bg-charcoalGray">
      {/* Search Button */}
      {isShowButtonSearch ? (
        <Button
          label={t("Search")}
          isDefault={true}
          className="gap-[2px] text-sm py-2 w-full"
          onClick={handleNavigate}
          leftIcon={<MagnifyingGlass size={20} color={isDarkMode ? "#000" : "#fff"} />}
        />
      ) : null}

      {/* Quick */}

      {/* <HStack className="w-full" justifyContent="between" gap={2}>
        {quickButtons.map((i) => {
          if (i.tooltip) {
            return (
              <Tooltip key={i.id} className="w-full" message={i.tooltip} position="top">
                {handleRenderQuick(i)}
              </Tooltip>
            );
          } else {
            return handleRenderQuick(i);
          }
        })}
      </HStack> */}
    </DivShadow>
  );
};

export default NavigateSearch;
